import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { WaiterHttpService } from "src/app/share-modul/services/common/waiter-http-service";
import { environment } from "src/environments/environment";

const WTR_MENU_API = environment.apiURL + '/api/wtr/Menu/';

@Injectable({
  providedIn: 'root'
})

export class MenuService {

  //#region Fields
  //#endregion

  //#region Constructor
  constructor( private _waiterHttpService: WaiterHttpService, private _httpClient: HttpClient) {
  }
  //#endregion

  //#region Public Methods
  getmostordereditems(venueId: string) {
    var url = WTR_MENU_API + "getmostordereditems?venueId=" + venueId;
    return this._waiterHttpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  viewmenu(venueId: string) {
    var url = WTR_MENU_API + "viewmenu?venueId=" + venueId;
    return this._waiterHttpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }
  //#endregion
}
